import {NftIdsModel} from '../_models/nft-ids-model';

export const productVariantIdentifierToIds = (queryString: string): NftIdsModel => {
    const splits = queryString.split('-');
    return {
        variantId: parseInt(splits[splits.length-1]),
        productId: parseInt(splits[splits.length-2])
    }
}
